import {
    BriefListItem,
    BriefView,
    BriefViewCounts,
    BuyerBrief,
    BuyerBriefIntake,
    BuyerBriefJob,
} from "../../types/BuyerBriefTypes";
import { PagerObject } from "../../types/DataFetchingTypes";
import { safeDELETE, safeGET, safePOST } from "./SafeClient";

export function createBrief(intake: BuyerBriefIntake, abort?: any): Promise<BuyerBrief> {
    return safePOST("/api/briefs", intake, abort);
}

/** Every brief in the view, newest first: no page params means no paging. */
export function listBriefs(
    // The param is `tab` on the wire; the server kept the name so old bundles
    // keep working. `all` is the safe default: it hides nothing.
    view: BriefView = "all",
    abort?: any
): Promise<PagerObject<BriefListItem[]>> {
    return safeGET(`/api/briefs?sort=id&order=DESC&tab=${view}`, abort);
}

/** Totals per view, unaffected by any search term. */
export function getBriefCounts(abort?: any): Promise<BriefViewCounts> {
    return safeGET("/api/briefs/counts", abort);
}

export function getBriefById(id: number, abort?: any): Promise<BuyerBrief> {
    return safeGET(`/api/briefs/${id}`, abort);
}

export function getBriefStatus(id: number, abort?: any): Promise<BuyerBriefJob> {
    return safeGET(`/api/briefs/${id}/status`, abort);
}

export function getBriefHtml(id: number, abort?: any): Promise<string> {
    return safeGET(`/api/briefs/${id}/html`, abort);
}

export function runBrief(id: number, abort?: any): Promise<BuyerBrief> {
    return safePOST(`/api/briefs/${id}/run`, {}, abort);
}

export function deleteBrief(id: number, abort?: any): Promise<{ deleted: boolean }> {
    return safeDELETE(`/api/briefs/${id}`, undefined, abort);
}
